module.exports = function() {
  return new Worker(__webpack_public_path__ + "c91997ff98ebe5fdcb36.worker.js");
};